import { useEffect, useState } from "react";
import { apiJson } from "../../utils/api";
import useSeo from "../../hooks/useSeo";

const PRESET_QUESTIONS = [
  "外地户口在杭州能领证吗？",
  "领证需要什么材料？",
  "现在还需要户口本吗？",
  "周末可以领证吗？",
  "9月9日能不能领？",
];

export default function MarriageAssistant() {
  const [question, setQuestion] = useState(PRESET_QUESTIONS[0]);
  const [city, setCity] = useState("杭州市");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useSeo({
    title: "AI领证助手",
    metaDescription: "基于政策知识库回答结婚登记材料、全国通办与地点问题，并展示官方来源。",
    path: "/marriage/assistant",
  });

  const ask = async (e, qOverride) => {
    e?.preventDefault?.();
    const q = (qOverride ?? question).trim();
    if (!q) return;
    if (qOverride) setQuestion(qOverride);
    setLoading(true);
    try {
      const { res, data } = await apiJson("/api/marriage/assistant/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question: q, city }),
      });
      if (!res.ok) throw new Error(data?.detail || "暂时无法回答");
      setResult(data);
    } catch (err) {
      setResult({ answer: err.message || "暂时无法回答", citations: [] });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    ask(null, PRESET_QUESTIONS[0]);
  }, []);

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="text-3xl font-extrabold">🤖 AI领证助手</h1>
      <p className="text-sm text-gray-500">点下方常见问题会立刻作答。政策类只根据知识库回答，不编造当地细则。</p>
      <div className="flex flex-wrap gap-2 text-xs">
        {PRESET_QUESTIONS.map((item) => (
          <button
            key={item}
            type="button"
            className="px-3 py-1 rounded-full bg-white border hover:bg-rose-50"
            onClick={() => ask(null, item)}
          >
            {item}
          </button>
        ))}
      </div>
      <form onSubmit={(e) => ask(e)} className="bg-white rounded-2xl p-4 space-y-3">
        <input
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="当前城市（可选）"
          className="w-full border rounded-xl px-3 py-2"
        />
        <textarea
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          rows={3}
          className="w-full border rounded-xl px-3 py-2"
        />
        <button disabled={loading} className="px-5 py-2 rounded-xl bg-rose-500 text-white">
          {loading ? "检索知识库..." : "提问"}
        </button>
      </form>
      {result ? (
        <div className="bg-white rounded-2xl p-5 space-y-3 border">
          <p className="text-xs text-gray-400">问题类型：{result.question_type}</p>
          <p className="whitespace-pre-wrap text-gray-800">{result.answer}</p>
          {(result.citations || []).map((c) => (
            <div key={c.id || c.title} className="text-xs text-gray-500 border-t pt-3">
              <p>政策依据：{c.source_name || c.name}</p>
              <p>更新时间：{c.last_verified_at || "—"}</p>
              {c.official_url ? (
                <p>
                  官方来源：
                  <a className="text-rose-600 ml-1" href={c.official_url} target="_blank" rel="noreferrer">
                    {c.official_url}
                  </a>
                </p>
              ) : null}
            </div>
          ))}
          <p className="text-xs text-amber-800">{result.disclaimer}</p>
        </div>
      ) : null}
    </div>
  );
}
